import { render, staticRenderFns } from "./PatentInventorForm.vue?vue&type=template&id=05d08c53&"
import script from "./PatentInventorForm.vue?vue&type=script&lang=js&"
export * from "./PatentInventorForm.vue?vue&type=script&lang=js&"
import style0 from "./PatentInventorForm.vue?vue&type=style&index=0&id=05d08c53&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports